/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from '@material-ui/core'
import React from 'react'

import { getTranslate } from '../../localization'
import { FullJobStatueAndDetails } from '../../types/BulkAccessManagement'
import { JobStatusForRateplan } from '../../types/rateplan'
import { JobDetailsModalRow } from './JobDetailsModalRow'
import useStyles from './styles/jobDetails.styles'

interface JobDetailsRowProps {
  userRows?: FullJobStatueAndDetails[]
  ratePlanRows?: JobStatusForRateplan[]
}
export const JobDetailsModalTable: React.FC<JobDetailsRowProps> = ({
  userRows,
  ratePlanRows
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {!!userRows?.length && (
        <div className={classes.tableHeaderForModal}>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Email')}
            </Typography>
          </div>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Accommodations')}
            </Typography>
          </div>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Status')}
            </Typography>
          </div>
        </div>
      )}
      {!!ratePlanRows?.length && (
        <div className={classes.tableHeaderForModal}>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Rateplan Name')}
            </Typography>
          </div>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Rateplan Code')}
            </Typography>
          </div>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Status')}
            </Typography>
          </div>
        </div>
      )}
      {!!userRows?.length &&
        userRows.map((user, index) => (
          <JobDetailsModalRow key={index} data={user} />
        ))}
      {!!ratePlanRows?.length &&
        ratePlanRows.map((ratePlan, index) => (
          <JobDetailsModalRow key={index} ratePlanData={ratePlan} />
        ))}
    </div>
  )
}
